import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../../../../../../../../core/service/auth.service";
import { DeletePaymentRequest } from "../interfaces/delete-card.interface";
import { environment } from "../../../../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DeleteCardService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,

  ) { }

  deletePaymentMethod(paymentMethodId: string): Observable<any> {
    try {
      const token = this.authService.getToken();

      const headers = new HttpHeaders({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      });

      const payment_method_id: DeletePaymentRequest = {
        payment_method_id: paymentMethodId,

      };

      return this.http.delete(
        `${environment.apiUrl}/payment/method/delete`,
        { headers, body: payment_method_id }
      ).pipe(
        catchError((error) => throwError(() => error))
      );
    } catch (error) {
      return throwError(() => error);
    }
  }
}
